<script>
import ItemTabSignedIn from "./combine-with/ItemTabSignedIn.svelte";
import DocumentTab from "../nav-tabs/DocumentTab.svelte";
import NewItem from "../product-list/NewItem.svelte";

let elslutbleck = {
  title: "Elslutbleck ES19 12/24V Rättvänd",
  picture:
    "https://shopgib.gothes.se/public/images/ftg10/img320x320/152090_17971.jpg",
  info: {
    article: "152090",
    brand: "Safetron",
    surface: "Rostfri",
  },
};
let elslutbleck2 = {
  title: "ANSLUNTNINGSKABEL 5M FÖR 18, 28, 60 STEP",
  picture:
    "https://shopgib.gothes.se/public/images/ftg10/img320x320/152090_17971.jpg",
  info: {
    article: "152093",
    brand: "Safetron",
    surface: "Rostfri",
  },
};
let history = {
  billnumber: "417046",
  billdate: "2020-11-25",
  quantity: "1",
  price: "1571.45",
  sum: "1571.45",
  errand: "132991",
  ordernumber: "O12318-8338",
  delivdate: "2020-12-10",
  period: "2020-10-10",
  periodquantity: "0",
  periodsum: "21597.45",
};
</script>

<ul class="nav nav-tabs nav-tabs-brand-primary hidden-xs" role="tablist">
  <li role="presentation" class="active">
    <a
      href="#tillb-info"
      aria-controls="tillb-info"
      role="tab"
      data-toggle="tab"
    >Kombinera med
    </a>
  </li>

  <li role="presentation" class="">
    <a
      href="#kat-info"
      aria-controls="kat-info"
      role="tab"
      data-toggle="tab"
    >Alternativ</a>
  </li>

  <li role="presentation">
    <a href="#history" aria-controls="history" role="tab" data-toggle="tab">Din
      köphistorik</a>
  </li>

  <li role="presentation">
    <a
      href="#documents"
      aria-controls="documents"
      role="tab"
      data-toggle="tab"
    >Dokument</a>
  </li>
</ul>
<div
  role="tabpanel"
  class="tab-pane tab-pane-visible-xs active"
  id="tillb-info"
>
  <NewItem item="{elslutbleck}" />
  <NewItem item="{elslutbleck2}" />
</div>

<div role="tabpanel" class="tab-pane tab-pane-visible-xs" id="kat-info">
  Alternativ
</div>
<div role="tabpanel" class="tab-pane tab-pane-visible-xs" id="history">
  <div class="pt-xs">
    <div class="table-responsive">
      <table class="table table-striped">
        <thead>
          <tr class="history-font">
            <th class="first">Ärende</th>
            <th>Antal</th>
            <th>Beräknad lev.tid</th>
            <th>Anmärkning</th>
          </tr>
        </thead>
        <tbody>
          <tr class="odd">
            <td class="first"><a href="#">{history.billnumber}</a></td>
            <td>{history.billdate}</td>
            <td>{history.quantity}</td>
            <td>{history.price}</td>
          </tr>

          <tr class="even">
            <td class="first"><a href="#">{history.billnumber}</a></td>
            <td>{history.billdate}</td>
            <td>{history.quantity}</td>
            <td>{history.price}</td>
          </tr>
        </tbody>
      </table>
      <table class="table table-striped">
        <thead>
          <tr class="history-font">
            <th class="first">Faktura</th>
            <th>Fakturadatum</th>
            <th>Antal</th>
            <th>Pris</th>
            <th>Belopp</th>
            <th>Ärende</th>
            <th>Ert beställningsnummer</th>
            <th>Lev.datum</th>
            <th>Anmärkning</th>
          </tr>
        </thead>
        <tbody>
          <tr class="odd">
            <td class="first"><a href="#">{history.billnumber}</a></td>
            <td>{history.billdate}</td>
            <td>{history.quantity}</td>
            <td>{history.price} SEK</td>
            <td>{history.sum} SEK</td>
            <td><a href="#">{history.errand}</a></td>
            <td>{history.ordernumber}</td>
            <td>{history.delivdate}</td>
            <td></td>
          </tr>

          <tr class="even">
            <td class="first"><a href="#">{history.billnumber}</a></td>
            <td>{history.billdate}</td>
            <td>{history.quantity}</td>
            <td>{history.price} SEK</td>
            <td>{history.sum} SEK</td>
            <td><a href="#">{history.errand}</a></td>
            <td>{history.ordernumber}</td>
            <td>{history.delivdate}</td>
            <td></td>
          </tr>

          <tr class="odd">
            <td class="first"><a href="#">{history.billnumber}</a></td>
            <td>{history.billdate}</td>
            <td>{history.quantity}</td>
            <td>{history.price} SEK</td>
            <td>{history.sum} SEK</td>
            <td><a href="#">{history.errand}</a></td>
            <td>{history.ordernumber}</td>
            <td>{history.delivdate}</td>
            <td></td>
          </tr>

          <tr class="even">
            <td class="first"><a href="#">{history.billnumber}</a></td>
            <td>{history.billdate}</td>
            <td>{history.quantity}</td>
            <td>{history.price} SEK</td>
            <td>{history.sum} SEK</td>
            <td><a href="#">{history.errand}</a></td>
            <td>{history.ordernumber}</td>
            <td>{history.delivdate}</td>
            <td></td>
          </tr>
        </tbody>
      </table>
      <table class="table table-striped">
        <thead>
          <tr class="history-font">
            <th class="first">Period</th>
            <th>Antal</th>
            <th>Belopp</th>
          </tr>
        </thead>
        <tbody>
          <tr class="odd">
            <td class="first"><a href="#">{history.period}</a></td>
            <td style="width:8rem;">{history.periodquantity}</td>
            <td style="width:15rem;">{history.periodsum} SEK</td>
          </tr>

          <tr class="even">
            <td class="first"><a href="#">{history.period}</a></td>
            <td>{history.periodquantity}</td>
            <td>{history.periodsum} SEK</td>
          </tr>

          <tr class="odd">
            <td class="first"><a href="#">{history.period}</a></td>
            <td>{history.periodquantity}</td>
            <td>{history.periodsum} SEK</td>
          </tr>

          <tr class="even">
            <td class="first"><a href="#">{history.period}</a></td>
            <td>{history.periodquantity}</td>
            <td>{history.periodsum} SEK</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<div role="tabpanel" class="tab-pane tab-pane-visible-xs" id="documents">
  <DocumentTab />
</div>
